import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AggregatedStatus } from '@vi-iot/client';

@Pipe({
  name: 'kanbanColumnName',
  standalone: true,
})
export class KanbanColumnNamePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(columnName: string): string {
    switch (columnName) {
      case AggregatedStatus.Offline:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.OFFLINE'
        );
      case AggregatedStatus.Maintenance:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.MAINTENANCE'
        );
      case AggregatedStatus.Error:
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.FAULT');
      case AggregatedStatus.WorksProperly:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.WORKS_PROPERLY'
        );
      case AggregatedStatus.RemoteDiagnosticSession:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.REMOTE_DIAGNOSTICS_SESSION'
        );
      case AggregatedStatus.Locked:
        return this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.LOCKED'
        );
      case AggregatedStatus.NBIoT:
        return this.translateService.instant('+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.NBIOT');
      default:
        return columnName;
    }
  }
}
